import Swiper, {Autoplay} from "../../node_modules/swiper";

export default () => {
  let swiperPartner = new Swiper(".slider-partner", {
    modules: [Autoplay],
    slidesPerView: 2, 
    spaceBetween: 30,
    loop: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    breakpoints: {
        521: {
            slidesPerView: 4, 
        },
        768: {
            slidesPerView: 6,
        },
    },
  });
}